import styled, { css } from 'styled-components';

import { donedealBreakpoints } from 'styled-system';
import { ArrowBackOutlineIc } from '@dsch/dd-icons';

import { Link } from '../../Toolkit/Button/Link';
import { LinkButton } from '../../Toolkit/Button/LinkButton';
import { ThemeTypes } from '../../../types/Theme.namespace';

const Container = styled.nav`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.donedeal.spacing.S12} 0;
`;

const BackIcon = styled(ArrowBackOutlineIc)`
  height: 24px;
  width: 24px;

  ${donedealBreakpoints.media.medium} {
    height: 20px;
    width: 20px;
  }
`;

const BorderCSS = css`
  // Prevents shift when the element is focused
  border: 2px solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

const BackButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.donedeal.spacing.M16};
  overflow: visible;
  ${({ theme }) => theme.donedeal.fontSize.M14};
  ${BorderCSS}

  ${donedealBreakpoints.media.medium} {
    ${({ theme }) => theme.donedeal.fontSize.M16};
    margin-right: ${({ theme }) => theme.donedeal.spacing.M24};
  }
`;

const BackText = styled.span`
  display: none;

  ${donedealBreakpoints.media.medium} {
    margin-left: ${({ theme }) => theme.donedeal.spacing.S4};
    display: inline-block;
  }
`;

const BreadcrumbsOuterContainer = styled.div`
  overflow: auto;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Chrome/Safari/Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  // Ensures the container is the same height as the contents
  height: 32px; // 24px line height of contents + 4px padding of inner container (top and bottom) + 4px border of elements (top and bottom)
`;

const BreadcrumbsInnerContainer = styled.div`
  display: flex;
  // Prevents the focus state from being cut off by the "overflow: auto" attribute of the parent container
  padding: ${({ theme }) => theme.donedeal.spacing.S2};
`;

const BreadcrumbAndDividerContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BreadcrumbTextCSS = css`
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};
  ${({ theme }) => theme.donedeal.fontSize.M14};

  ${donedealBreakpoints.media.medium} {
    ${({ theme }) => theme.donedeal.fontSize.M16};
  }
`;

const BreadcrumbLink = styled(Link)`
  ${BreadcrumbTextCSS};
  ${BorderCSS}
`;

const BreadcrumbText = styled.span<{ color: ThemeTypes.Colors }>`
  ${BreadcrumbTextCSS};
  color: ${({ theme, color }) => theme.donedeal.colors[color]};
`;

export {
  Container,
  BreadcrumbsOuterContainer,
  BreadcrumbsInnerContainer,
  BackIcon,
  BackButton,
  BackText,
  BreadcrumbAndDividerContainer,
  BreadcrumbLink,
  BreadcrumbText,
};
